export const SET_CART_ID = "card.SET_CART_ID";
export const RESET_CART = "card.RESET_CART";
export const SET_ADD_CARD_ERROR = "card.SET_ADD_CARD_ERROR";
export const SET_CART_CARDS = "card.SET_CART_CARDS";
export const SET_UPDATE_CARD_ERROR = "card.SET_UPDATE_CARD_ERROR";
export const SET_LOADING_STATE = "card.SET_LOADING_STATE";

export const LOADING_EMUNS = Object.freeze({
  DEFAULT: "DEFAULT",
  LOADING: "LOADING",
  LOADED: "LOADED",
  ERROR: "ERROR",
});
